// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"30f0dc58","304":"623dfc9f","315":"009f3a01","319":"c459b05f","430":"b7bec0ee","453":"aa32f1f2","711":"d07c4200","713":"294c693b","847":"8e97054b"}[chunkId] + ".chunk.js";
};